import { render, staticRenderFns } from "./sysuser_auth_config.vue?vue&type=template&id=511b3c2d&scoped=true"
import script from "./sysuser_auth_config.vue?vue&type=script&lang=js"
export * from "./sysuser_auth_config.vue?vue&type=script&lang=js"
import style0 from "./sysuser_auth_config.vue?vue&type=style&index=0&id=511b3c2d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b3c2d",
  null
  
)

export default component.exports